import React, { useEffect, useState } from "react";
import "./Navbar.css";

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [popupOpen, setPopupOpen] = useState(false);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = () => {
      setActiveDropdown(null);
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const toggleDropdown = (name, e) => {
    e.stopPropagation();
    setActiveDropdown((prev) => (prev === name ? null : name));
  };

  return (
    <div>
      <nav className={`r-navbar ${mobileOpen ? "mobile-active" : ""}`}>
        <div className="r-nav-container">
          <a
            href="https://www.growthspreeofficial.com/"
            className="r-logo-link"
          >
            <img
              src="https://cdn.prod.website-files.com/6776747215b7d1c20a23913e/6827222ba47c14520facc74b_Group%201%20(1).webp"
              alt="GrowthSpree Logo"
              className="r-logo-img"
            />
          </a>

          <div className="r-nav-links-wrapper">
            <ul className="r-nav-links">
              {/* About */}
              <li
                className={`r-dropdown ${activeDropdown === "about" ? "active" : ""}`}
              >
                <button
                  className="r-drop-toggle"
                  onClick={(e) => toggleDropdown("about", e)}
                >
                  About Us
                </button>
                <ul className="r-drop-menu">
                  <li>
                    <a href="https://www.growthspreeofficial.com/about-us">
                      Team
                    </a>
                  </li>
                  <li>
                    <a href="https://www.growthspreeofficial.com/work-thesis-b2b-saas-demand-generation-approach">
                      Our Work Thesis
                    </a>
                  </li>
                  <li>
                    <a href="https://www.growthspreeofficial.com/ai-thesis-ai-powered-b2b-saas-marketing-agency">
                      Our AI Thesis
                    </a>
                  </li>
                </ul>
              </li>

              {/* Solutions */}
              <li
                className={`r-dropdown ${activeDropdown === "solutions" ? "active" : ""}`}
              >
                <button
                  className="r-drop-toggle"
                  onClick={(e) => toggleDropdown("solutions", e)}
                >
                  Solutions
                </button>
                <ul className="r-drop-menu">
                  <li>
                    <a href="https://www.growthspreeofficial.com/early-stage">
                      Early Stage
                    </a>
                  </li>
                  <li>
                    <a href="https://www.growthspreeofficial.com/scaleups">
                      Scaleup
                    </a>
                  </li>
                </ul>
              </li>

              <li>
                <a href="https://www.growthspreeofficial.com/case-studies">
                  Case Studies
                </a>
              </li>

              {/* Resources */}
              <li
                className={`r-dropdown ${activeDropdown === "resources" ? "active" : ""}`}
              >
                <button
                  className="r-drop-toggle"
                  onClick={(e) => toggleDropdown("resources", e)}
                >
                  Resources
                </button>
                <ul className="r-drop-menu">
                  <li>
                    <a
                      href="https://dribbble.com/GrowthSpree"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Creative Studio
                    </a>
                  </li>
                  <li>
                    <a href="https://www.growthspreeofficial.com/google-ads-health-checker">
                      Google Ads Health Analyzer
                    </a>
                  </li>
                  <li>
                    <a href="https://www.growthspreeofficial.com/blogs">
                      Blogs
                    </a>
                  </li>
                  <li>
                    <a href="https://www.growthspreeofficial.com/b2b-google-ads-waste-report-enterprise-saas">
                      Google Ads Waste Report
                    </a>
                  </li>
                  <li>
                    <a href="https://www.growthspreeofficial.com/free-google-ads-audit-b2b-saas-companies">
                      Free Google Ads Audit
                    </a>
                  </li>
                  <li>
                    <a href="https://www.growthspreeofficial.com/google-ads-agency-scorecard-b2b-saas-evaluation">
                      Agency Evaluation Scorecard
                    </a>
                  </li>
                  <li>
                    <a href="https://www.growthspreeofficial.com/contact-us">
                      Contact Us
                    </a>
                  </li>
                </ul>
              </li>
              <li
                className={`r-dropdown ${activeDropdown === "marketing-ai-agents" ? "active" : ""}`}
              >
                <button
                  className="r-drop-toggle"
                  onClick={(e) => toggleDropdown("marketing-ai-agents", e)}
                >
                  Marketing AI agents
                </button>
                <ul className="r-drop-menu">
                  <li>
                    <a href="https://www.growthspreeofficial.com/resources/google-ads-mcp">
                      Google Ads MCP
                    </a>
                  </li>
                  <li>
                    <a href="https://www.growthspreeofficial.com/resources/facebook-meta-ads-mcp">
                      Facebook (Meta) Ads MCP
                    </a>
                  </li>
                  <li>
                    <a href="https://www.growthspreeofficial.com/resources/google-analytics-ads-mcp">
                      Google Analytics Ads MCP
                    </a>
                  </li>
                  <li>
                    <a href="https://www.growthspreeofficial.com/resources/google-search-console-ads-mcp">
                      Google Search Console MCP
                    </a>
                  </li>
                  <li>
                    <a href="https://www.growthspreeofficial.com/resources/linkedin-ads-mcp">
                      LinkedIn Ads MCP
                    </a>
                  </li>
                  <li>
                    <a href="https://www.growthspreeofficial.com/resources/ai-marketing-mcp-b2b-saas">
                      AI Marketing MCP
                    </a>
                  </li>
                </ul>
              </li>

              <li>
                <a href="https://www.growthspreeofficial.com/careers">
                  Careers
                </a>
              </li>
            </ul>

            <div className="r-nav-cta">
              <button
                className="r-btn-founder"
                onClick={() => setPopupOpen(true)}
              >
                Talk to Founder
              </button>
            </div>
          </div>

          {/* Hamburger */}
          <div
            className="r-hamburger"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </nav>

      {/* POPUP */}
      {popupOpen && (
        <div className="r-popup-container">
          <div className="r-div-block-693">
            <div className="r-popup-close" onClick={() => setPopupOpen(false)}>
              ✕
            </div>

            <iframe
              src="https://meetings.hubspot.com/ishan-m?embed=true"
              width="100%"
              height="100%"
              frameBorder="0"
              title="Schedule a Meeting with Ishan"
            ></iframe>
            {/* <div
              className="meetings-iframe-container"
              data-src="https://meetings.hubspot.com/ishan-m?embed=true"
            >
            </div> */}
          </div>
        </div>
      )}
    </div>
  );
};

export default Navbar;
